"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HederaTokenManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "AccountHasNoRole",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "AccountHasUnlimitedSupplierAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "AddressZero",
        type: "error",
    },
    {
        inputs: [],
        name: "AdminKeyUpdateError",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AmountBiggerThanReserve",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "lengthArray1",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lengthArray2",
                type: "uint256",
            },
        ],
        name: "ArraysLengthNotEqual",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "FormatNumberIncorrect",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ref",
                type: "uint256",
            },
        ],
        name: "GreaterThan",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "HBARRescueError",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ref",
                type: "uint256",
            },
        ],
        name: "LessThan",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "s",
                type: "string",
            },
        ],
        name: "MoreThan100Error",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "amount",
                type: "int256",
            },
        ],
        name: "NegativeAmount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "RefundingError",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "code",
                type: "int256",
            },
        ],
        name: "ResponseCodeInvalid",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyKeyUpdateError",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "GrantTokenKyc",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "rescuer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "HBARRescued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "metadata",
                type: "string",
            },
        ],
        name: "MetadataSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "ReserveAddressChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "RevokeTokenKyc",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldAllowance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAllowance",
                type: "uint256",
            },
        ],
        name: "SupplierAllowanceDecreased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldAllowance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAllowance",
                type: "uint256",
            },
        ],
        name: "SupplierAllowanceIncreased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldAllowance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAllowance",
                type: "uint256",
            },
        ],
        name: "SupplierAllowanceReset",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenDeleted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenPaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "rescuer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenId",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "TokenRescued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "TokenTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenUnpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "string",
                        name: "tokenName",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "tokenSymbol",
                        type: "string",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "keyType",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes",
                                name: "publicKey",
                                type: "bytes",
                            },
                            {
                                internalType: "bool",
                                name: "isED25519",
                                type: "bool",
                            },
                        ],
                        internalType: "struct KeysLib.KeysStruct[]",
                        name: "keys",
                        type: "tuple[]",
                    },
                    {
                        internalType: "int64",
                        name: "second",
                        type: "int64",
                    },
                    {
                        internalType: "int64",
                        name: "autoRenewPeriod",
                        type: "int64",
                    },
                    {
                        internalType: "string",
                        name: "tokenMetadataURI",
                        type: "string",
                    },
                ],
                indexed: false,
                internalType: "struct IHederaTokenManager.UpdateTokenStruct",
                name: "updateTokenStruct",
                type: "tuple",
            },
        ],
        name: "TokenUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "burner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "TokensBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "minter",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "TokensMinted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "wiper",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "TokensWiped",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "TransfersFrozen",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "TransfersUnfrozen",
        type: "event",
    },
    {
        inputs: [],
        name: "ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "burn",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "decreaseSupplierAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deleteToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "freeze",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getAccountsWithRole",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getMetadata",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getNumberOfAccountsWithRole",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getReserveAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getReserveAmount",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum IRoles.RoleName",
                name: "role",
                type: "uint8",
            },
        ],
        name: "getRoleId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getRoles",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "rolesToReturn",
                type: "bytes32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "getSupplierAllowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantKyc",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "roles",
                type: "bytes32[]",
            },
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "grantRoles",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "grantSupplierRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "grantUnlimitedSupplierRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "increaseSupplierAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "string",
                                name: "name",
                                type: "string",
                            },
                            {
                                internalType: "string",
                                name: "symbol",
                                type: "string",
                            },
                            {
                                internalType: "address",
                                name: "treasury",
                                type: "address",
                            },
                            {
                                internalType: "string",
                                name: "memo",
                                type: "string",
                            },
                            {
                                internalType: "bool",
                                name: "tokenSupplyType",
                                type: "bool",
                            },
                            {
                                internalType: "int64",
                                name: "maxSupply",
                                type: "int64",
                            },
                            {
                                internalType: "bool",
                                name: "freezeDefault",
                                type: "bool",
                            },
                            {
                                components: [
                                    {
                                        internalType: "uint256",
                                        name: "keyType",
                                        type: "uint256",
                                    },
                                    {
                                        components: [
                                            {
                                                internalType: "bool",
                                                name: "inheritAccountKey",
                                                type: "bool",
                                            },
                                            {
                                                internalType: "address",
                                                name: "contractId",
                                                type: "address",
                                            },
                                            {
                                                internalType: "bytes",
                                                name: "ed25519",
                                                type: "bytes",
                                            },
                                            {
                                                internalType: "bytes",
                                                name: "ECDSA_secp256k1",
                                                type: "bytes",
                                            },
                                            {
                                                internalType: "address",
                                                name: "delegatableContractId",
                                                type: "address",
                                            },
                                        ],
                                        internalType: "struct IHederaTokenService.KeyValue",
                                        name: "key",
                                        type: "tuple",
                                    },
                                ],
                                internalType: "struct IHederaTokenService.TokenKey[]",
                                name: "tokenKeys",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "int64",
                                        name: "second",
                                        type: "int64",
                                    },
                                    {
                                        internalType: "address",
                                        name: "autoRenewAccount",
                                        type: "address",
                                    },
                                    {
                                        internalType: "int64",
                                        name: "autoRenewPeriod",
                                        type: "int64",
                                    },
                                ],
                                internalType: "struct IHederaTokenService.Expiry",
                                name: "expiry",
                                type: "tuple",
                            },
                        ],
                        internalType: "struct IHederaTokenService.HederaToken",
                        name: "token",
                        type: "tuple",
                    },
                    {
                        internalType: "int64",
                        name: "initialTotalSupply",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "tokenDecimals",
                        type: "int32",
                    },
                    {
                        internalType: "address",
                        name: "originalSender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "reserveAddress",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "role",
                                type: "bytes32",
                            },
                            {
                                internalType: "address",
                                name: "account",
                                type: "address",
                            },
                        ],
                        internalType: "struct IHederaTokenManager.RolesStruct[]",
                        name: "roles",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "account",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "allowance",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct IHederaTokenManager.CashinRoleStruct",
                        name: "cashinRole",
                        type: "tuple",
                    },
                    {
                        internalType: "string",
                        name: "tokenMetadataURI",
                        type: "string",
                    },
                ],
                internalType: "struct IHederaTokenManager.InitializeStruct",
                name: "init",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "isUnlimitedSupplierAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "rescue",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "rescueHBAR",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "resetSupplierAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeKyc",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "roles",
                type: "bytes32[]",
            },
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
        ],
        name: "revokeRoles",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "supplier",
                type: "address",
            },
        ],
        name: "revokeSupplierRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "unfreeze",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateReserveAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "tokenName",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "tokenSymbol",
                        type: "string",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "keyType",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes",
                                name: "publicKey",
                                type: "bytes",
                            },
                            {
                                internalType: "bool",
                                name: "isED25519",
                                type: "bool",
                            },
                        ],
                        internalType: "struct KeysLib.KeysStruct[]",
                        name: "keys",
                        type: "tuple[]",
                    },
                    {
                        internalType: "int64",
                        name: "second",
                        type: "int64",
                    },
                    {
                        internalType: "int64",
                        name: "autoRenewPeriod",
                        type: "int64",
                    },
                    {
                        internalType: "string",
                        name: "tokenMetadataURI",
                        type: "string",
                    },
                ],
                internalType: "struct IHederaTokenManager.UpdateTokenStruct",
                name: "updatedToken",
                type: "tuple",
            },
        ],
        name: "updateToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int64",
                name: "amount",
                type: "int64",
            },
        ],
        name: "wipe",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class HederaTokenManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.HederaTokenManager__factory = HederaTokenManager__factory;
HederaTokenManager__factory.bytecode = _bytecode;
HederaTokenManager__factory.abi = _abi;
